import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts"
import { ChartTooltip } from "./ChartTooltip"
import { ChartDataPoint } from "./hooks/useBrandComparison"
import { useMemo } from "react"

export default function BrandComparisonChart({
  filteredData,
  currentCompanyName,
  hoveredCompany,
}: {
  filteredData: ChartDataPoint[]
  currentCompanyName: string
  hoveredCompany: string | null
}) {
  const latestData = useMemo(
    () => filteredData?.[filteredData.length - 1],
    [filteredData],
  )
  const companies = useMemo(
    () =>
      latestData
        ? Object.entries(latestData.companies).map(([name, info]) => ({
            name,
            ...info,
          }))
        : [],
    [latestData],
  )

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={filteredData}>
        <CartesianGrid vertical={false} stroke="rgba(255, 255, 255, 0.25)" />
        <XAxis dataKey="date" height={20} stroke="rgba(255, 255, 255, 0.75)" />
        <YAxis
          domain={[0, 100]}
          stroke="rgba(255, 255, 255, 0.75)"
          width={40}
        />
        <Tooltip
          content={
            <ChartTooltip
              companies={companies}
              isLegendHover={false}
              currentCompany={currentCompanyName}
            />
          }
          cursor={{ fill: "transparent" }}
          wrapperStyle={{ outline: "none" }}
        />

        {companies.map(company => (
          <Bar
            key={company.name}
            dataKey={`companies.${company.name}.score`}
            name={company.name}
            barSize={30}
            fill={company.color}
            stroke={company.ai_generated ? "#FFD2E6" : undefined}
            strokeDasharray={company.ai_generated ? "10 10" : undefined}
            strokeWidth={company.ai_generated ? 2 : undefined}
            style={{
              transition: "opacity 0.2s ease",
              opacity:
                hoveredCompany &&
                company.name !== hoveredCompany &&
                company.name !== currentCompanyName
                  ? 0.3
                  : 1,
            }}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  )
}
